export default "__VITE_ASSET__HJ1mEvEx__"